<template>
  <div class="countdown-wrapper">
    <template v-if="icon">
      <img :src="require(`@/assets/svg/clock.svg`)" alt="clock" />
      <span v-if="!countdown" v-text="title" :style="{color: color, fontSize: `${size}px`}" />
    </template>
    <template v-else>
      <span v-text="timer" :style="{color: color, fontSize: `${size}px`}" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: Boolean,
      default: false,
    },
    countdown: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "rgba(0,0,0,.87)",
    },
    seconds: {
      type: [Number, String],
      default: 0,
    },
    minutes: {
      type: [Number, String],
      default: 0,
    },
    size: {
      type: Number,
      default: 16,
    },
    format: {
      type: String,
      default: "mm:ss"
    },
  },
  data() {
    return {
      date: null,
      interval: null,
      timeLeft: 0
    };
  },
  computed: {
    timer: function() {
      let result = [];
      if (this.minutes > 60) {
        let hours = Math.floor(this.timeLeft / (60 * 60)) % 60;
        result.push((hours.toString().length == 1  ? ('0'+hours) : hours));
      }
      let minutes = Math.floor(this.timeLeft / 60) % 60;
      result.push((minutes.toString().length == 1  ? ('0'+minutes) : minutes));
      let seconds = this.timeLeft % 60 // seconds
      result.push((seconds.toString().length == 1  ? ('0'+seconds) : seconds));
      return  result.join(':')
    },
  },
  methods: {
    setCountdownTime(minutes) {
      this.timeLeft = minutes * 60;
    },
    addMinutes(minutes) {
      this.timeLeft += minutes * 60;
    },
    addSeconds(seconds) {
      this.timeLeft += seconds;
    },
    applyCountdown() {
      this.interval = setInterval(() => {
        this.timeLeft -= 1;
      }, 1000);
    },
    clearCountdown() {
      if (this.timeLeft <= 0) {
        clearInterval(this.interval);
        this.timeLeft = 0;
        this.$emit("countdown-time-out");
      }
    },
  },
  watch: {
    minutes: {
      handler: "addMinutes",
      immediate: true,
    },
    seconds: {
      handler: "addSeconds",
      immediate: true,
    },
    timer: {
      handler: "clearCountdown",
      immediate: true,
    },
  },
  mounted() {
    this.applyCountdown();
  },
};
</script>

<style scoped lang="scss">
.countdown-wrapper {
  display: inline-block;

  img {
    vertical-align: middle;
    margin-right: 7px;
  }

  span {
    vertical-align: middle;
  }
}
</style>
